const REFRESH_TOKEN: string = 'refresh_token';

export function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN);
}
export function setRefreshToken(value: string | null) {
    if (value) localStorage.setItem(REFRESH_TOKEN, value);
    else localStorage.removeItem(REFRESH_TOKEN);
}

export function parseToDescriptions(data: Array<{Id: number; Name: string}>): Array<{Id: number; Description: string}> {
    if (!Array.isArray(data)) throw 'input data is not array';
    return data.map(item => ({Id: item.Id, Description: item.Name}));
}

export function generateId() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return (
        '_' +
        Math.random()
            .toString(36)
            .substr(2, 9)
    );
}
